/**
 * 요청 id로 사용할 UUID v4를 생성
 * @description
 * - crypto.randomUUID는 secure context(HTTPS/localhost)에서만 제공되므로 로컬 HTTP 환경용 폴백함께 반영
 */
export const createRequestId = () =>
  globalThis.crypto?.randomUUID?.() ??
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
    const random = (Math.random() * 16) | 0;
    return (character === 'x' ? random : (random & 0x3) | 0x8).toString(16);
  });
